// This data is used in cache exchange. Unfortunatly, urql doesn't support passing data to the cache exchange.
// So we need to pass it as a global variable.
export const roomData: { _room_id: string | null; _user_id: string | null } = {
  _room_id: null,
  _user_id: null,
};
